import React, {useState} from "react"
import {DisplayProductAttribute} from "../../../dtos/orderResponse"
import {postActionLog, ButtonActionTypes} from "../../../services/order/TrackOrderActions"
import {getCaseId} from "../../../utils/UrlParser"
import {Button, Card, CardContent, Grid, Typography} from "@mui/material"
const caseId = getCaseId()

interface DisplayProductAttributesProps {
	displayProductAttribute: DisplayProductAttribute[]
	orderNumber: string
	lineItemId: string
}

const DisplayProductAttributes = (props: DisplayProductAttributesProps) => {
	const displayProductAttribute = props.displayProductAttribute
	const [showDisplayData, setShowDisplayData] = useState(true)

	const switchViews = () => {
		postActionLog(
			{
				event: ButtonActionTypes.ClickSwitchItemViewButton,
				actionMetaData: {
					orderNumber: props.orderNumber,
					lineItemId: props.lineItemId,
				},
			},
			caseId
		)
		setShowDisplayData(!showDisplayData)
	}

	return props.displayProductAttribute && Object.keys(props.displayProductAttribute).length > 0 ? (
		<Card>
			<CardContent
				style={{
					paddingBottom: "0px",
				}}
			>
				<Grid container direction="row" justifyContent="space-between" alignItems="center">
					<Button
						fullWidth
						style={{maxHeight: "30px", minHeight: "20px", margin: "0 auto 0.5em auto"}}
						color="primary"
						variant="contained"
						onClick={switchViews}
					>
						<Typography variant="subtitle1" style={{fontWeight: 600}}>
							{showDisplayData ? "Switch to Internal view" : "Switch to Customer view"}
						</Typography>
					</Button>
				</Grid>
				{displayProductAttribute &&
					displayProductAttribute.map((selections, index) => (
						<Grid container justifyContent="space-between" key={selections.key + index.toString()}>
							<Grid item xs={6}>
								<Typography variant="subtitle1" key={index.toString() + selections.key}>
									{showDisplayData
										? selections.keyDisplayName
											? selections.keyDisplayName
											: ""
										: selections.key
										? selections.key
										: ""}
								</Typography>
							</Grid>
							<Grid item xs={6}>
								<Typography
									variant="subtitle1"
									key={selections.keyDisplayName + index.toString()}
									style={{fontWeight: 600}}
								>
									{showDisplayData
										? selections.valueDisplayName
											? selections.valueDisplayName
											: ""
										: selections.value
										? selections.value
										: ""}
								</Typography>
							</Grid>
						</Grid>
					))}
			</CardContent>
		</Card>
	) : (
		<></>
	)
}

export default DisplayProductAttributes

//Customer view
//Internal view
